// extracted by mini-css-extract-plugin
export default {"Header":"header-module_Header_FXXIK","ExitButtonLabel":"header-module_ExitButtonLabel_1hIjy"};